import profilelogo from "../Images/profilelogo.webp";
// import docnlplogo from "../Images/docnlp.webp";
/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */
// import Logo from "../Pages/website/images/Logo.svg";
/* Commenting end. ray using AI Agent. 24/08/2026 */
/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */
/* PNG wordmark; slogan is HTML so it stays readable at 100% zoom. */
import Logo from "../Pages/website/images/Logo.png";
/* Code end. ray using AI Agent. 24/08/2026 */
import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect } from "react";
/* Added the following code for restore.ray using AI Agent. 10/08/2026. Code Start */
import SearchComp from "./Search";
/* Code end. ray using AI Agent. 10/08/2026 */
/* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */
import {
  isLearnerPreviewActive,
  setLearnerPreviewActive,
  clearLearnerPreview,
  isRealAdminUser,
  /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
  getViewAsSession,
  clearViewAsSession,
  /* Code end. ray using AI Agent. 24/07/2026 */
} from "../progressApi";
/* Code end. Ray using AI Agent. 24/07/2026 */
 
const Header = () => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  /* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */
  const [learnerPreview, setLearnerPreview] = useState(() =>
    isLearnerPreviewActive()
  );
  const [canPreview, setCanPreview] = useState(() => isRealAdminUser());
  /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
  const [viewAs, setViewAs] = useState(() => getViewAsSession());
  /* Code end. ray using AI Agent. 24/07/2026 */
  /* Added the following code for userprofile.ray using AI Agent. 13/08/2026. Code Start */
  const [displayName, setDisplayName] = useState(
    () => localStorage.getItem("firstname") || ""
  );
  /* Code end. ray using AI Agent. 13/08/2026 */
  /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
  const [tenant, setTenant] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tenant")) || null;
    } catch {
      return null;
    }
  });
  const [isTenantAdmin, setIsTenantAdmin] = useState(
    () => localStorage.getItem("isTenantAdmin") === "true"
  );
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(
    () => localStorage.getItem("isPlatformAdmin") === "true"
  );
  /* Code end. ray using AI Agent. Oct 9, 2026 */

  useEffect(() => {
    const sync = () => {
      setLearnerPreview(isLearnerPreviewActive());
      setCanPreview(isRealAdminUser());
      /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
      setViewAs(getViewAsSession());
      /* Code end. ray using AI Agent. 24/07/2026 */
    };
    window.addEventListener("selftrainai:learner-preview-changed", sync);
    /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
    window.addEventListener("selftrainai:view-as-changed", sync);
    /* Code end. ray using AI Agent. 24/07/2026 */
    window.addEventListener("auth-login", sync);
    /* Added the following code for userprofile.ray using AI Agent. 13/08/2026. Code Start */
    const syncName = () => setDisplayName(localStorage.getItem("firstname") || "");
    window.addEventListener("auth-login", syncName);
    window.addEventListener("selftrainai:profile-updated", syncName);
    /* Code end. ray using AI Agent. 13/08/2026 */
    /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
    const syncTenant = () => {
      try {
        setTenant(JSON.parse(localStorage.getItem("tenant")) || null);
      } catch {
        setTenant(null);
      }
      setIsTenantAdmin(localStorage.getItem("isTenantAdmin") === "true");
      setIsPlatformAdmin(localStorage.getItem("isPlatformAdmin") === "true");
    };
    window.addEventListener("auth-login", syncTenant);
    /* Code end. ray using AI Agent. Oct 9, 2026 */
    return () => {
      window.removeEventListener("selftrainai:learner-preview-changed", sync);
      /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
      window.removeEventListener("selftrainai:view-as-changed", sync);
      /* Code end. ray using AI Agent. 24/07/2026 */
      window.removeEventListener("auth-login", sync);
      /* Added the following code for userprofile.ray using AI Agent. 13/08/2026. Code Start */
      window.removeEventListener("auth-login", syncName);
      window.removeEventListener("selftrainai:profile-updated", syncName);
      /* Code end. ray using AI Agent. 13/08/2026 */
      /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
      window.removeEventListener("auth-login", syncTenant);
      /* Code end. ray using AI Agent. Oct 9, 2026 */
    };
  }, []);
  /* Code end. Ray using AI Agent. 24/07/2026 */
 
  // Function to toggle the dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
 
  // Function to close the dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };
 
  // Add event listener to handle clicks outside the dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("firstname");
    /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
    localStorage.removeItem("tenant");
    localStorage.removeItem("isPlatformAdmin");
    localStorage.removeItem("isTenantAdmin");
    /* Code end. ray using AI Agent. Oct 9, 2026 */
    /* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */
    try {
      sessionStorage.removeItem("selftrainai_learner_preview");
      sessionStorage.removeItem("selftrainai_admin_restore");
    } catch {
      /* ignore */
    }
    /* Code end. Ray using AI Agent. 24/07/2026 */
    toast.success("You have been logged out !");
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };
 
  return (
    <header className="bg-gradient-to-r from-slate-900 to-cyan-600 rounded-t-lg">
      <nav className="px-4 lg:px-4">
        {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
        {/* Extra vertical room so the logo can match the slogan width without clipping. */}
        <div className="flex items-center justify-between min-h-16 py-1.5">
        {/* Code end. ray using AI Agent. 24/08/2026 */}
          {/* <h1 className="ml-4">DocNLP</h1> */}
          {/* Added the following code for restore.ray using AI Agent. 10/08/2026. Code Start */}
          {/* Logo + site search typeahead grouped on the left. */}
          <div className="flex items-center gap-4 min-w-0">
            {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
            {/* Logo stretches to the slogan's width (w-0 min-w-full ignores the PNG's intrinsic size). */}
            <Link to={'/home'} className="ml-12 flex h-10 flex-col items-center justify-center">
            {/* Code end. ray using AI Agent. 24/08/2026 */}
              {/* Added the following code for title_change.ray using AI Agent. 10/08/2026. Code Start */}
              {/* Commenting the following code for logo.ray using AI Agent. 19/08/2026. Comment Start */}
              {/* <img className="w-32 h-22 ml-12 mt-2 " src={Logo} alt="SelfTrainAI logo"/> */}
              {/* Commenting end. ray using AI Agent. 19/08/2026 */}
              {/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */}
              {/* <img className="h-7 w-auto object-contain" src={Logo} alt="SelfTrainAI logo"/> */}
              {/* <img className="block h-12 w-auto object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" src={Logo} alt="SelfTrainAI logo"/> */}
              {/* <img className="block h-10 w-auto object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" src={Logo} alt="SelfTrainAI logo"/> */}
              {/* <span className="mt-0.5 whitespace-nowrap text-xs font-medium tracking-wide text-white">
                From Learning AI to Building AI
              </span> */}
              {/* Commenting end. ray using AI Agent. 24/08/2026 */}
              {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
              {tenant?.branding?.logoUrl ? (
                <img
                  className="h-[28px] w-auto max-w-[140px] object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]"
                  src={tenant.branding.logoUrl}
                  alt={tenant.branding.title || tenant.name}
                />
              ) : (
                <img className="h-[26px] w-auto object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" src={Logo} alt="SelfTrainAI logo"/>
              )}
              <span className="whitespace-nowrap text-[10px] font-medium leading-none tracking-wide text-white">
                {tenant?.branding?.title || "From Learning AI to Building AI"}
              </span>
              {/* Code end. ray using AI Agent. Oct 9, 2026 */}
            </Link>
            {/* Search sits beside the logo; width keeps the input usable in the header row. */}
            <div className="w-56 sm:w-72 md:w-80">
              <SearchComp />
            </div>
            {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
            {tenant?.name && tenant.slug !== "selftrainai" && (
              <span className="hidden lg:inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-white/20 text-white border border-white/30 backdrop-blur-sm shadow-sm">
                🏢 {tenant.name}
              </span>
            )}
            {/* Code end. ray using AI Agent. Oct 9, 2026 */}
          </div>
          {/* Code end. ray using AI Agent. 10/08/2026 */}
 
          {/* <img src="../images/hamburger-menu.svg"/> */}
          <div className="pr-10 flex">
            <button
              type="button"
              className="mr-7 text-sm bg- rounded-full md:mr-0  items-right flex items-center"
              id="user-menu-button"
              aria-expanded={isDropdownOpen}
              onClick={toggleDropdown}
            >
           
              <img
                className="w-8 h-8 rounded-full"
                src={profilelogo}
                alt="userphoto"
              />
              {/* Dropdown menu */}
              <div className="text-lg text-white ml-2">
                {/* Added the following code for userprofile.ray using AI Agent. 13/08/2026. Code Start */}
                Hi, {displayName}
                {/* Code end. ray using AI Agent. 13/08/2026 */}
                {/* Commenting the following code for userprofile.ray using AI Agent. 13/08/2026. Comment Start */}
                {/* Hi, {localStorage.getItem("firstname")} */}
                {/* Commenting end. ray using AI Agent. 13/08/2026 */}
              </div>
              {isDropdownOpen && (
                <div
                  className="z-50 absolute mt-64 mr-56 w-48 bg-white rounded-lg duration-700 shadow-xl border border-gray-100"
                  id="user-dropdown"
                  ref={dropdownRef}
                >
                  <ul className="text-center space-y-3 p-3">
                    {/* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */}
                    {/* Wire Dashboard to /home; remove placeholder Profile/Settings (#) to avoid dead clicks. */}
                    <li>
                      <Link
                        to="/home"
                        className="text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        Dashboard
                      </Link>
                    </li>
                    {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
                    {(isTenantAdmin || isPlatformAdmin) && (
                      <li>
                        <Link
                          to="/tenant-admin"
                          className="text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white flex items-center justify-between"
                          onClick={() => setIsDropdownOpen(false)}
                        >
                          <span>Organization Admin</span>
                        </Link>
                      </li>
                    )}
                    {/* Added the following code for platform_tenants.ray using AI Agent. 10/10/2026. Code Start */}
                    {isPlatformAdmin && (
                      <li>
                        <Link
                          to="/platform-tenants"
                          className="text-md text-cyan-800 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white flex items-center justify-between"
                          onClick={() => setIsDropdownOpen(false)}
                        >
                          <span>Platform Tenants</span>
                        </Link>
                      </li>
                    )}
                    {/* Code end. ray using AI Agent. 10/10/2026 */}
                    {/* Code end. ray using AI Agent. Oct 9, 2026 */}
                    {/* Added the following code for userprofile.ray using AI Agent. 13/08/2026. Code Start */}
                    <li>
                      <Link
                        to="/profile"
                        className="text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        My Profile
                      </Link>
                    </li>
                    {/* Code end. ray using AI Agent. 13/08/2026 */}
                    <li>
                      <button
                        type="button"
                        className="w-full pb-2 text-md font-bold text-black p-2 cursor-pointer hover:bg-cyan-900 hover:text-white rounded-md"
                        onClick={handleLogout}
                      >
                        Sign out
                      </button>
                    </li>
                    {/* Code end. ray using AI Agent. Aug 12, 2026 */}
                    {/* Commenting the following code for ux.ray using AI Agent. Aug 12, 2026. Comment Start */}
                    {/*
                    <li>
                      <Link to={"#"}className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 rounded-4xl hover:text-white">My Profile</Link>
                    </li>
                    <li>
                      <Link to={"#"} className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white">Dashboard</Link>
                    </li>
                    <li>
                      <Link to={"#"} className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white">Settings</Link>
                    </li>
                    <li></li>
                    <Link className=" pb-2 text-md font-bold text-black p-2  cursor-pointer hover:bg-cyan-900 hover:text-white rounded-md" onClick={handleLogout}>Sign out</Link>
                    <br/>
                    */}
                    {/* Commenting end. ray using AI Agent. Aug 12, 2026 */}
                  </ul>
                </div>
              )}
            </button>
          </div>
        </div>
      </nav>
      {/* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */}
      {/* Site-wide learner preview / view-as bar — enter/exit from any page. */}
      {/* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */}
      {viewAs?.userId ? (
        <div className="px-4 py-2 flex flex-wrap items-center justify-center gap-3 text-sm bg-amber-50 text-amber-950 border-t border-amber-200">
          <span className="font-semibold">
            Viewing as {viewAs.name || viewAs.email} — progress, locks, and lesson UI
            match this learner (read-only).
          </span>
          <button
            type="button"
            className="font-semibold underline"
            onClick={() => {
              clearViewAsSession();
              toast.success("Exited view-as mode");
              /* Added the following code for progress.ray using AI Agent. 20/08/2026. Code Start */
              navigate("/home");
              /* Code end. ray using AI Agent. 20/08/2026 */
              /* Commenting the following code for progress.ray using AI Agent. 20/08/2026. Comment Start */
              // navigate("/learning-progress");
              /* Commenting end. ray using AI Agent. 20/08/2026 */
            }}
          >
            Exit view-as
          </button>
        </div>
      ) : canPreview || learnerPreview ? (
      /* Code end. ray using AI Agent. 24/07/2026 */
        <div
          className={`px-4 py-2 flex flex-wrap items-center justify-center gap-3 text-sm ${
            learnerPreview
              ? "bg-cyan-50 text-cyan-950 border-t border-cyan-200"
              : "bg-slate-800/80 text-white border-t border-cyan-700/40"
          }`}
        >
          {learnerPreview ? (
            <>
              <span className="font-semibold">
                Preview as learner is on — progress, locks, and lesson UI match a learner.
              </span>
              <button
                type="button"
                className="font-semibold underline"
                onClick={() => {
                  clearLearnerPreview();
                  toast.success("Exited learner preview");
                }}
              >
                Exit preview
              </button>
            </>
          ) : (
            <button
              type="button"
              className="font-semibold bg-[#0891b2] text-white rounded-md px-3 py-1 hover:bg-[#0e7490]"
              onClick={() => {
                setLearnerPreviewActive(true);
                toast.success("Preview as learner enabled");
              }}
            >
              Preview as learner
            </button>
          )}
        </div>
      ) : null}
      {/* Code end. Ray using AI Agent. 24/07/2026 */}
    </header>
  );
};
 
export default Header;






// import profilelogo from "../Images/profilelogo.webp";
// import docnlplogo from "../Images/docnlp.webp";
// import React, { useState, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import { useEffect } from "react";
// import SearchComp from "./Search";
// import SearchIcon from '@mui/icons-material/Search';

// const Header = () => {
//   const navigate = useNavigate();
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Function to toggle the dropdown
//   const toggleDropdown = () => {
//     setIsDropdownOpen(!isDropdownOpen);
//   };

//   // Function to close the dropdown when clicking outside
//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setIsDropdownOpen(false);
//     }
//   };

//   // Add event listener to handle clicks outside the dropdown
//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("firstname");
//     toast.success("You have been logged out !");
//     setTimeout(() => {
//       navigate("/");
//     }, 2000);
//   };

//   return (
//     <header className="bg-gradient-to-r from-slate-900 to-cyan-600 rounded-t-lg">
//       <nav className="px-4 lg:px-4">
//         <div className="flex items-center justify-between h-16">
//           {/* <h1 className="ml-4">DocNLP</h1> */}
//           <Link to={'/home'}>
//           <img className="w-32 h-32 ml-7 mt-2 " src={docnlplogo} alt="DocNlplogo"/>
//           </Link>

//           {/* <img src="../images/hamburger-menu.svg"/> */}
//           <div className="flex">

//           <SearchComp/>

//           <div className="ml-4 pr-10 flex">

//             <button
//               type="button"
//               className="mr-7 text-sm bg- rounded-full md:mr-0  items-right flex items-center"
//               id="user-menu-button"
//               aria-expanded={isDropdownOpen}
//               onClick={toggleDropdown}
//             >
            
//               <img
//                 className="w-8 h-8 rounded-full"
//                 src={profilelogo}
//                 alt="userphoto"
//               />
//               {/* Dropdown menu */}
//               <div className="text-lg text-white ml-2">
//                 Hi, {localStorage.getItem("firstname")}
//               </div>
//               {isDropdownOpen && (
//                 <div
//                   className="z-50 absolute mt-56 mr-56 w-32 bg-white rounded-lg duration-700"
//                   id="user-dropdown"
//                   ref={dropdownRef}
//                 >
//                   <ul className="text-center space-y-4 p-4">
//                     <li>
                      
//                       <Link to={"#"}className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 rounded-4xl hover:text-white">My Profile</Link>
//                     </li>
//                     <li>
                      
//                       <Link to={"#"} className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white">Dashboard</Link>
//                     </li>
//                     <li>
                      
//                       <Link to={"#"} className=" text-md text-gray-700 font-semibold p-2 rounded-md hover:bg-cyan-900 hover:text-white">Settings</Link>
//                     </li>
//                     <li>
                      
//                     </li>

//                     <Link className=" pb-2 text-md font-bold text-black p-2  cursor-pointer hover:bg-cyan-900 hover:text-white rounded-md" onClick={handleLogout}>Sign out</Link>
//                     <br/>                   
//                   </ul>
//                 </div>
//               )}
//             </button>
//           </div>
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;
